export const ROUTE_LINE_WEIGHT = 3;
export const ROUTE_LINE_OPACITY = 0.9;
export const ROUTE_LINE_DASH_ARRAY = '10 8';
